<script>
import Basic from '../../ADDITIONAL_HOST/components/basic';
import mixin from '../mixin';
import { planTypes } from '@/common/constants';
export default {
  props: {
    configPlanTileStatus: {
      type: Object,
      default: () => ({}),
    },
    isAddon: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [mixin],
  render(createElement) {
    const { $props, $data, $listeners } = this;
    return createElement(Basic, {
      key: planTypes[planTypes.ADDITIONAL_CO_EDITOR],
      props: { ...$props, ...$data },
      on: $listeners
    });
  },
};
</script>
